import { useRecoilState } from 'recoil';
import { useFeatureFlags } from 'src/hooks/useFeatureFlags';
import { UserPermissions, useUserPermissions } from 'src/hooks/useUserPermissions';
import { customerModeActiveState } from 'src/stores/customer-mode';

export const useCustomerMode = () => {
  const [active, setActive] = useRecoilState(customerModeActiveState);
  const customerModeFlagEnabled = useFeatureFlags('customerMode');
  const hasCustomerModePermission = useUserPermissions(UserPermissions.CAN_USE_CUSTOMER_MODE);
  const customerModeAvailable = customerModeFlagEnabled && hasCustomerModePermission;

  return {
    customerModeAvailable,
    customerModeActive: customerModeAvailable && active,
    setCustomerModeActive: setActive,
  };
};
